import { ModuleFE_Facility } from './ModuleFE_Facility.js';
export const ModulePackFE_Facility = [ModuleFE_Facility];
//# sourceMappingURL=module-pack.js.map